import { observer } from 'mobx-react-lite'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { type OCRScopingJobMainPanelViewModel } from '@/features/jobs/scoping/OCRScopingJobMainPanelViewModel'
import { OCRScopeJobDetailBodyMain } from '@/features/jobs/scoping/components/OCRScopeJobDetailBody'
import { OCRScopeJobDetailBodyBasicInformationContainer } from '@/features/jobs/scoping/components/OCRScopeJobDetailBodyBasicInformation/OCRScopeJobDetailBodyBasicInformationContainer'
import { OCRScopeJobDetailBodyLegendInformationContainer } from '@/features/jobs/scoping/components/OCRScopeJobDetailBodyLegendInformation/OCRScopeJobDetailBodyLegendInformationContainer'

export interface OCRScopeJobDetailBodyMainContainerProps {
  vm: OCRScopingJobMainPanelViewModel
}

export const OCRScopeJobDetailBodyMainContainer = observer(
  function OCRScopeJobDetailBodyMainContainer({
    vm,
  }: OCRScopeJobDetailBodyMainContainerProps) {
    return vm.selectJob.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => (
        <OCRScopeJobDetailBodyMain
          basicInformation={
            <OCRScopeJobDetailBodyBasicInformationContainer vm={vm} />
          }
          legendInformation={
            <OCRScopeJobDetailBodyLegendInformationContainer vm={vm} />
          }
        />
      ),
    })
  },
)
